<template>
	<header class="app-header" :class="{
		'app-header_menu-show': isMenuVisible
	}">
		<div class="container" role="banner">

			<div class="row gx-md-5 align-items-center justify-content-between">
				<div class="col-auto">
					<app-logo/>
				</div>
				<div class="col-auto d-lg-none">
					<button type="button" @click="isMenuVisible = !isMenuVisible" class="btn app-header__menu-button">
						<span class="app-header__menu-button-bar"></span>
						<span class="app-header__menu-button-bar"></span>
						<span class="app-header__menu-button-bar"></span>
						<span class="app-header__menu-button-bar"></span>
					</button>
				</div>
				<div class="col-12 col-lg-auto">

					<ul class="nav app-header__menu">
						<li v-for="item in menu" :key="item.id" class="nav-item">
							<router-link class="nav-link" :to="item.path">{{item.name}}</router-link>
						</li>
						<li class="d-lg-none">
							<a href="#" @click.prevent="logout" class="nav-link text-danger">Выйти</a>
						</li>
					</ul>

				</div>
				<div v-if="!isGuest" class="col-auto d-none d-lg-block">
					Привет, #{{appconf.user.id}}
					<a href="#" @click.prevent="logout" class="ms-2 text-dark">Выйти</a>
				</div>
			</div>

<!--			<div class="row align-items-center">-->
<!--				<div class="col-9">-->
<!--					<nav aria-label="breadcrumb">-->
<!--						<ol class="breadcrumb align-items-center m-0">-->
<!--							<li v-for="item in breadcrumbs" :key="item.url" class="breadcrumb-item" :class="{-->
<!--								active: item.active-->
<!--							}">-->
<!--								<a v-if="item.active" :href="item.url">{{item.name}}</a>-->
<!--								<span class="v-else">{{item.name}}</span>-->
<!--							</li>-->
<!--						</ol>-->
<!--					</nav>-->
<!--				</div>-->
<!--				<div class="col-3 ms-auto">-->

<!--&lt;!&ndash;					<form action="/" method="post">&ndash;&gt;-->
<!--&lt;!&ndash;						<input type="search" class="form-control app-header__search" placeholder="Поиск...">&ndash;&gt;-->
<!--&lt;!&ndash;					</form>&ndash;&gt;-->

<!--				</div>-->
<!--			</div>-->

		</div>
	</header>
</template>
<script>
import AppLogo from '@/components/app-logo'

let menu = [
	{
		id: 'login',
		path: {name: 'sign-in'},
		name: 'Авторизация',
		auth: false
	},
	{
		id: 'register',
		path: {name: 'sign-up'},
		name: 'Регистрация',
		auth: false
	},
	{
		id: 'my-books',
		path: {name: 'shelves-my'},
		name: 'Мои книги',
		auth: true
	},
	{
		id: 'shop-books',
		path: {name: 'shelves-shop'},
		name: 'Планирую купить',
		auth: true
	}
];

export default {
	props: {
		breadcrumbs: {
			type: Array,
			default() {
				return [
					{url: '/', name: 'Главная', active: false}
				];
			}
		},
	},
	data() {
		return {
			isGuest: !this.appconf.user.id,
			isMenuVisible: false,
			menu
		}
	},
	methods: {
		logout() {
			localStorage.removeItem('user');
			window.location = '/';
		}
	},
	watch: {
		$route() {
			if (this.isMenuVisible) {
				this.isMenuVisible = false;
			}
		}
	},
	beforeMount() {
		// show only menu items that user have access
		this.menu = this.menu.filter(item => item.auth === !!this.appconf.user.id);
	},
	components: {
		'app-logo': AppLogo
	}
}
</script>
<style lang="sass">
.app-header
	padding: 1rem 0
	margin-bottom: 1px
	background-color: white

	//.breadcrumb-item
	//	& + .breadcrumb-item
	//		&::before
	//			margin: 4px 10px 0
	//			content: '|'

	&__title
		display: inline-block
		margin: 0
		font: 1.75rem $font-primary

	&__menu
		.nav-link
			color: $dark

			&:hover,
			&:focus
				//color: $primary
				text-decoration: underline

	&__menu-button
		padding: 5px

		&:hover,
		&:focus
			color: $primary

	&__menu-button-bar
		display: block
		width: 26px
		height: 1px
		border-radius: 1px
		background-color: currentColor
		transition: all 0.5s

		&:not(:last-child)
			margin-bottom: 7px

		&:nth-child(3)
			margin-top: -8px

	&__search
		background-color: white

		&:focus
			background-color: white
			border-color: $primary

@media screen and (max-width: map-get($grid-breakpoints, lg) - 1)
	.app-header
		&__menu
			display: none
			margin: 1rem (-$container-padding-x) -1rem

			.nav-item
				&:not(:last-child)
					border-bottom: 1px solid #f5f5f5

			.nav-link
				padding: 1rem

		&_menu-show
			.app-header__menu
				display: block

			.app-header__menu-button-bar
				&:nth-child(1)
					transform: scaleX(0)
					opacity: 0
				&:nth-child(2)
					transform: rotate(135deg)
				&:nth-child(3)
					transform: rotate(45deg)
				&:nth-child(4)
					transform: scaleX(0)
					opacity: 0
</style>